import React, { useEffect } from 'react';
import { getOptimizedImageUrl } from '../lib/cms';

export default function GalleryModal({ images = [], initialIndex = 0, onClose, isOpen }) {
  const [currentIndex, setCurrentIndex] = React.useState(initialIndex);

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') handleNext();
      if (e.key === 'ArrowLeft') handlePrev();
    };

    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, currentIndex, images.length]);

  if (!isOpen || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  const handleNext = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 sm:p-6"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Galleri fuldskærm"
    >
      {/* Close Button */}
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white/80 hover:text-white p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors z-50"
        aria-label="Luk galleri"
      >
        <i className="fa-solid fa-xmark text-xl" aria-hidden="true"></i>
      </button>

      {/* Prev Button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={handlePrev}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 sm:p-4 rounded-full bg-white/10 hover:bg-white/20 transition-colors z-50"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left text-xl" aria-hidden="true"></i>
        </button>
      )}

      {/* Next Button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={handleNext}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 sm:p-4 rounded-full bg-white/10 hover:bg-white/20 transition-colors z-50"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right text-xl" aria-hidden="true"></i>
        </button>
      )}

      {/* Image container */}
      <div
        className="max-w-5xl max-h-[85vh] flex flex-col items-center justify-center relative select-none"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={getOptimizedImageUrl(currentImage, { width: 1400, quality: 85 })}
          alt={`Ibjerget gallerivisning ${currentIndex + 1}`}
          className="max-h-[80vh] max-w-full rounded-xl object-contain shadow-2xl animate-fade-in"
        />
        <div className="mt-4 text-xs font-medium text-white/70 tracking-wider">
          {currentIndex + 1} af {images.length}
        </div>
      </div>
    </div>
  );
}
